import { FC, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";

import { ERoutes } from "../../constants/routes";
import { logoutUser } from "../../store/auth/slice";



const LogoutView: FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(logoutUser());
    navigate(ERoutes.Login);
  }, []);

  return null;
};

export default LogoutView;
